import { render, staticRenderFns } from "./article9.vue?vue&type=template&id=7b5181e9&scoped=true"
var script = {}
import style0 from "./article9.vue?vue&type=style&index=0&id=7b5181e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5181e9",
  null
  
)

export default component.exports